<template>
    <div v-bind:class="{ 'epoq-home-background': mode === 'home' }">
        <mainindex>
            <!-- <div class="log" v-if="islogmode && gen._UID"> -->
            <div v-if="islogmode" class="log">
                <d-close @close="islogmode = !islogmode" />
                <mainlog></mainlog>
            </div>
            <div v-if="!islogmode" class="content">
                <!-- <div class="content" v-if="gen._UID && !islogmode"> -->

                <!-- HEADER -->
                <page-header v-if="mode !== 'home' && mode !== 'startprj'" :menu-tree="menu" :cur-page="mode" @nav="go($event)" @save-prj="savePrj()" @save-b2b-prj="saveB2bPrj()" @new-prj="newPrj" @enable-maintenance="enableMaintenance" @save-b2b-template="saveB2bTemplate" @close-b2b-template="closeB2bTemplate" @openlogspanel="toggleLogsPanel"></page-header>
                <!-- HEADER -->

                <!-- BODY -->
                <div class="body h-100" v-bind:class="[paddingClass]">
                    <router-view v-if="$route.name !== null"></router-view>
                    <div v-else style="height: 100%">
                        <template v-if="mode === 'home'">
                            <home @new-prj="newPrj" @new-b2b-prj="newB2bPrj" @load-prj="go('projects.my')" @nav="go($event)"></home>
                        </template>
                        <template v-else-if="mode === 'startprj'">
                            <start-prj confirm-room-type @nav="go($event)"></start-prj>
                        </template>
                        <template v-else-if="mode === 'projects.my'">
                            <prj-finder
                                v-if="isCustomer"
                                key="GUEST"
                                filter="GUEST"
                                :title="_trans('My Projects')"
                                :rows-number="10"
                                order-by="11D"
                                :cols="[
                                    { id: 'guest.fullname', title: _trans('customer name') },
                                    { id: 'des', title: _trans('project name'), order: 6 },
                                    { id: 'shopdes', title: 'store', order: 8 }
                                ]"
                                @open="openPrj($event)"
                            ></prj-finder>
                            <prj-finder
                                v-if="!isCustomer"
                                key="MY"
                                filter="MY"
                                :title="_trans('My Projects')"
                                :rows-number="10"
                                order-by="11D"
                                :cols="[
                                    { id: 'guest.mail', title: _trans('customer e-mail') },
                                    { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: _trans('project name'), order: 6 },
                                    { id: 'shopdes', title: 'store', order: 8 },
                                    { id: 'status', title: _trans('status'), order: 4 },
                                    { id: 'lastedit', title: 'last edit', order: 11 }
                                ]"
                                @open="openPrj($event)"
                            ></prj-finder>
                            <prj-finder
                                v-if="!isCustomer && user.seller > 2"
                                key="AWAITING"
                                filter="AWAITING"
                                :title="_trans('Projects Awaiting Approval')"
                                :rows-number="10"
                                order-by="11"
                                :cols="[
                                    { id: 'userdes', title: _trans('seller name'), order: 9 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: _trans('name'), order: 6 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'lastedit', title: 'last edit', order: 11 }
                                ]"
                                @open="openPrj"
                            ></prj-finder>
                        </template>
                        <template v-else-if="mode === 'projects.b2b' && isB2BBuild">
                            <prj-finder-b2b
                                v-if="user.seller > 2"
                                key="B2B"
                                filter="B2B"
                                :title="_trans('B2B Projects')"
                                :rows-number="10"
                                order-by="datalastedit"
                                :cols="[
                                    { id: 'sellerdes', title: _trans('seller name'), order: 'sellerdes' },
                                    { id: 'shopdes', title: _trans('store'), order: 'shopdes' },
                                    { id: 'id', title: 'id', order: 'id' },
                                    { id: 'des', title: _trans('name'), order: 'des' },
                                    { id: 'status', title: _trans('status'), order: 4 },
                                    { id: 'datalastedit', title: 'last edit', order: 'datalastedit' },
                                    { id: 'assign', title: null }
                                ]"
                                @open="openB2bPrj"
                            ></prj-finder-b2b>

                            <prj-finder
                                key="B2BCHILD"
                                filter="B2BCHILD"
                                :title="_trans('Assigned B2B child projects')"
                                :rows-number="10"
                                order-by="11"
                                :cols="[
                                    { id: 'userdes', title: _trans('seller name'), order: 9 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: _trans('name'), order: 6 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'lastedit', title: 'last edit', order: 11 }
                                ]"
                                @open="openB2bChild"
                            ></prj-finder>
                        </template>
                        <template v-else-if="mode === 'projects.ext'">
                            <prj-finder
                                key="UNASSIGNED"
                                filter="UNASSIGNED"
                                :title="_trans('Unassigned Projects')"
                                :rows-number="10"
                                order-by="0"
                                :cols="[
                                    { id: 'guest.mail', title: _trans('customer e-mail') },
                                    { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                    { id: 'guest.cap', title: _trans('postal code'), order: 5 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: _trans('name'), order: 6 },
                                    { id: 'lastedit', title: 'last edit', order: 11 },
                                    { id: 'assign', title: null }
                                ]"
                                @open="openPrj"
                            ></prj-finder>
                            <prj-finder
                                key="OTHERPRJ"
                                filter="OTHERPRJ"
                                :title="_trans('Other Projects In My Store')"
                                :rows-number="10"
                                order-by="0"
                                :cols="[
                                    { id: 'userdes', title: _trans('seller name'), order: 9 },
                                    { id: 'guest.mail', title: _trans('customer e-mail') },
                                    { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: _trans('name'), order: 6 },
                                    { id: 'shopdes', title: 'store', order: 8 },
                                    { id: 'status', title: _trans('status'), order: 4 },
                                    { id: 'lastedit', title: 'last edit', order: 11 },
                                    { id: 'assign', title: null }
                                ]"
                                @open="openPrj"
                            ></prj-finder>
                        </template>
                        <template v-else-if="mode === 'projects.clinv'">
                            <prj-finder
                                key="CLOSED"
                                filter="CLOSED"
                                :title="_trans('Closed Projects')"
                                :rows-number="5"
                                order-by="0"
                                :cols="[
                                    { id: 'userdes', title: _trans('seller name'), order: 9 },
                                    { id: 'guest.mail', title: _trans('customer e-mail') },
                                    { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: _trans('name'), order: 6 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'lastedit', title: 'last edit', order: 11 }
                                ]"
                                @open="openPrj"
                            ></prj-finder>
                            <prj-finder
                                key="INACTIVE"
                                filter="INACTIVE"
                                :title="_trans('Inactive Projects')"
                                :rows-number="5"
                                order-by="0"
                                :cols="[
                                    { id: 'guest.mail', title: _trans('customer e-mail') },
                                    { id: 'guest.fullname', title: _trans('customer name'), order: 5 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: _trans('name'), order: 6 },
                                    { id: 'lastedit', title: 'last edit', order: 11 }
                                ]"
                                @open="openPrj"
                            ></prj-finder>
                            <prj-finder
                                key="ANONYMOUS"
                                filter="ANONYMOUS"
                                :title="_trans('Anonymized projects')"
                                :rows-number="5"
                                order-by="0"
                                :cols="[
                                    { id: 'userdes', title: _trans('seller name'), order: 9 },
                                    { id: 'id', title: 'id', order: 0 },
                                    { id: 'des', title: _trans('name'), order: 6 },
                                    { id: 'shop', title: 'shop', order: 8 },
                                    { id: 'lastedit', title: 'last edit', order: 11 }
                                ]"
                                @open="openPrj"
                            ></prj-finder>
                        </template>
                        <template v-else-if="mode === 'notifications'">
                            <notifications></notifications>
                        </template>
                        <template v-else-if="mode === 'shops'">
                            <adm-shops></adm-shops>
                        </template>
                        <template v-else-if="mode === 'catalogs'">
                            <adm-catalogs></adm-catalogs>
                        </template>
                        <template v-else-if="mode === 'itemsearch'">
                            <article-search @nav="go($event)"></article-search>
                        </template>
                        <template v-else-if="mode === 'compositions'" @nav="go($event)">
                            <compositions :apply-header="true" @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'configurator'">
                            <configure lockvisual="60;45;45;false;0;360;0;90;800;10000;false" @nav="go($event)"></configure>
                        </template>
                        <template v-else-if="mode === '3dview'">
                            <view3d lockvisual="60;45;45;false;0;360;0;90;800;10000;false" @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === '2dview'">
                            <view2d use-old-sidebar :show-wall-y-tool="true" @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'renders'">
                            <renders @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'offerview'">
                            <offer></offer>
                        </template>
                        <template v-else-if="mode === 'summary'">
                            <prj-summary :info-max-length="2048" />
                        </template>
                        <template v-else-if="mode === 'customerinfo'">
                            <customer-info />
                        </template>
                        <template v-else-if="mode === 'prjlog'">
                            <prj-log />
                        </template>
                        <template v-else-if="mode === 'delivery'">
                            <delivery class="mt-5" />
                        </template>
                        <template v-else-if="mode === 'promo'">
                            <promotions />
                        </template>
                        <template v-else-if="mode === 'anonymize'">
                            <anonymize class="mt-5" />
                        </template>
                        <template v-else-if="mode === 'json'">
                            <d-json :value="prj" />
                        </template>
                        <template v-else-if="mode === 'myprofile'">
                            <my-profile />
                        </template>
                        <template v-else-if="mode === 'orderview'">
                            <order />
                        </template>
                        <template v-else-if="mode === 'commercialmodels'">
                            <comm-models />
                        </template>
                        <template v-else-if="mode === 'galleryroles'">
                            <gallery-roles class="mt-5"></gallery-roles>
                        </template>
                        <template v-else-if="mode === 'templateview'">
                            <template-view @nav="go($event)"></template-view>
                        </template>
                        <template v-else-if="mode === 'childprjview'">
                            <child-prj-view @nav="go($event)"></child-prj-view>
                        </template>
                        <template v-else-if="mode === 'b2b.startprj'">
                            <start-prj confirm-room-type @nav="go($event)"></start-prj>
                        </template>
                        <template v-else-if="mode === 'b2b.itemsearch'">
                            <article-search @nav="go($event)"></article-search>
                        </template>
                        <template v-else-if="mode === 'b2b.compositions'" @nav="go($event)">
                            <compositions :apply-header="true" @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'b2b.2dview'">
                            <view2d :show-wall-y-tool="true" @nav="go($event)"></view2d>
                        </template>
                        <template v-else-if="mode === 'b2b.3dview'">
                            <view3d @nav="go($event)"></view3d>
                        </template>
                        <template v-else-if="mode === 'b2b.configurator'">
                            <configure @nav="go($event)"></configure>
                        </template>
                        <template v-else-if="mode === 'b2b.offerview'">
                            <offer @nav="go($event)"></offer>
                        </template>
                        <template v-else-if="mode === 'b2b.orderview'">
                            <order @nav="go($event)"></order>
                        </template>
                        <template v-else-if="mode === 'b2b.summary'">
                            <prj-summary :info-max-length="2048" @nav="go($event)"></prj-summary>
                        </template>
                        <template v-else-if="mode === 'b2b.renders'">
                            <renders @nav="go($event)" />
                        </template>
                        <template v-else-if="mode === 'b2b.customerinfo'">
                            <customer-info />
                        </template>
                        <template v-else-if="mode === 'b2b.prjlog'">
                            <prj-log @nav="go($event)" @detachchild="detachB2bChild"></prj-log>
                        </template>
                        <template v-else-if="mode === 'parent.prjlog'">
                            <prj-log-parent @nav="go($event)"></prj-log-parent>
                        </template>
                        <template v-else-if="mode === 'b2b.variants'">
                            <variant-selection @nav="go($event)"></variant-selection>
                        </template>
                        <template v-else>
                            <h1>::::{{ mode }}::::</h1>
                        </template>
                    </div>
                </div>
                <!-- BODY -->
            </div>
            <home v-else @new-prj="newPrj" @load-prj="go('projects.my')" @nav="go($event)"></home>
            <h5 v-if="accessError" class="text-danger text-center mt-5" v-text="_trans(accessError)"></h5>
        </mainindex>

        <app-settings v-if="showSettings" @close="showSettings = false"></app-settings>

        <!--DIALOGS-->
        <modal-set-customer ref="setCustomer"></modal-set-customer>
        <modal-set-permissions ref="setPermissions"></modal-set-permissions>
        <b-toast v-if="!isMaintenance && isMaintenanceBooked && ($store.state.commonStore.profile || ($store.state.commonStore.profile && $store.state.commonStore.profile.guest))" :visible="true" :no-auto-hide="true" toaster="b-toaster-bottom-right" variant="warning" :title="_trans('maintenance mode')">
            <div>
                <span v-text="_trans('Maintenance booked from')"></span>
                <span>{{ $store.state.commonStore.maintenance.startDateTimeUTC | moment("D MMM YYYY HH:mm") }}</span>
                <span v-text="_trans('to')"></span>
                <span>{{ $store.state.commonStore.maintenance.endDateTimeUTC | moment("D MMM YYYY HH:mm") }}</span>
            </div>
            <div v-if="$store.state.commonStore.profile.admin" class="mt-3">
                <b-btn variant="warning" size="sm" block @click="cancelBookManteinance" v-text="_trans('Booking cancellation')"></b-btn>
            </div>
        </b-toast>
        <b-toast v-else-if="isMaintenance && (!$store.state.commonStore.profile || ($store.state.commonStore.profile && $store.state.commonStore.profile.guest))" :visible="true" :no-auto-hide="true" toaster="b-toaster-bottom-right" variant="warning" :title="_trans('maintenance mode')">
            <span v-text="_trans('System is in maintenance mode')"></span>
            <br />
            <div v-if="$store.state.commonStore.maintenance.startDateTimeUTC && $store.state.commonStore.maintenance.endDateTimeUTC" style="font-size: smaller">
                <span v-text="_trans('from')"></span>
                <span>{{ $store.state.commonStore.maintenance.startDateTimeUTC | moment("D MMM YYYY HH:mm") }}</span>
                <span v-text="_trans('to')"></span>
                <span>{{ $store.state.commonStore.maintenance.endDateTimeUTC | moment("D MMM YYYY HH:mm") }}</span>
            </div>
        </b-toast>
        <b-modal v-else-if="isMaintenance && $store.state.commonStore.profile" variant="warning" size="xl" visible no-close-on-backdrop no-close-on-esc hide-footer hide-header centered>
            <div class="py-5 px-3 text-center">
                <h1>
                    <span v-text="_trans('System is in maintenance mode')"></span>
                    <br />
                    <div v-if="$store.state.commonStore.maintenance.startDateTimeUTC && $store.state.commonStore.maintenance.endDateTimeUTC" style="font-size: smaller">
                        <span v-text="_trans('from')"></span>
                        <span>{{ $store.state.commonStore.maintenance.startDateTimeUTC | moment("D MMM YYYY HH:mm") }}</span>
                        <span v-text="_trans('to')"></span>
                        <span>{{ $store.state.commonStore.maintenance.endDateTimeUTC | moment("D MMM YYYY HH:mm") }}</span>
                    </div>
                </h1>
                <div v-if="$store.state.commonStore.profile.admin" class="d-flex justify-content-center mt-4">
                    <b-btn variant="secondary" @click="unlockManteinance" v-text="_trans('Unlock maintenance')"></b-btn>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import "../../../scss/epoq.scss";
    import { LogwebAPI, NextApiClient } from "@3cad/nextcore";
    import { App, loadJson } from "@3cad/nextcore";
    import { GeneralCadCmd } from "@3cad/nextcore";
    import { Auth } from "@3cad/nextcore";
    import { bus } from "@store/dau";
    import { UserAgentApplication } from "msal";
    import { ProjectsAPI } from "@3cad/nextcore";

    import index from "@configurator/index";

    import admCatalogs from "@erp/pages/adm/admincatalogs";
    import admShops from "@erp/pages/adm/adminshops";
    import commModels from "@erp/pages/base/cmodels";
    import order from "@custom/pages/order";
    let lastConfigPage = null;
    const EpoqB2BBuild = process.dau._BUILD_TYPE === "EPOQB2B";

    import { parentPrjManager } from "@custom/_modules/ParentProjectStore.js";
    import { B2bHeaderC } from "@custom/_modules/ParentProject";
    import { epoqRecomputePrices } from "@custom/_modules/EpoqStatic";

    /** Pages to check exit
     * @type {[*]}
     */
    let exitPages = ["home", "projects.my", "projects.ext", "projects.clinv", "projects.b2b", "promo", "notifications", "myprofile", "shops", "catalogs", "delivery", "anonymize", "commercialmodels"];

    export default {
        mixins: [index],
        components: {
            admCatalogs,
            admShops,
            commModels,
            order,
            modalSetCustomer: () => import("@custom/dialogs/modalSetCustomer"),
            modalSetPermissions: () => import("@custom/dialogs/modalSetPermissions"),
            prjFinderB2b: () => import("@custom/comp/prjFinderB2B"),
            templateView: () => import("@custom/pages/templateView"),
            childPrjView: () => import("@custom/pages/childPrjView"),
            variantSelection: () => import("@custom/pages/variantSelection"),
            prjLogParent: () => import("@custom/pages/prjLogParent")
        },
        data() {
            let isB2BBuild = EpoqB2BBuild;
            let menu = isB2BBuild ? require("@assets/epoq/json/menub2b.json") : require("@assets/epoq/json/menu.json");
            return {
                isB2BBuild: isB2BBuild,
                menu: menu
            };
        },
        computed: {
            preferences() {
                return this.$store.getters["getPreferences"];
            },
            paddingClass() {
                switch (this.mode) {
                    case "home":
                    case "startprj":
                        return "no-menu";
                    // return 'no-menu' + ((this.isCustomer) ? ' customer-padding' : '');
                    case "projects":
                    case "projects.my":
                    case "projects.ext":
                    case "projects.b2b":
                    case "projects.clinv":
                    case "notification":
                    case "promo":
                    case "myprofile":
                    case "shops":
                    case "catalogs":
                    case "delivery":
                    case "galleryroles":
                    case "anonymize":
                    case "notifications":
                    case "commercialmodels":
                        return "mid-menu";
                    case "b2b.compositions":
                    case "b2b.itemsearch":
                    case "b2b.2dview":
                    case "b2b.3dview":
                    case "b2b.configurator":
                    case "b2b.renders":
                    case "b2b.offerview":
                    case "b2b.orderview":
                    case "b2b.summary":
                    case "b2b.prjlog":
                    case "b2b.customerinfo":
                    case "b2b.variants":
                        return "full-b2b-menu";
                    // return 'mid-menu' + ((this.isCustomer) ? ' customer-padding' : '');
                    default:
                        return "full-menu";
                    // return 'full-menu' + ((this.isCustomer) ? ' customer-padding' : '');
                }
            },
            countryCode() {
                let chainId = this.preferences.config.chainid;
                return this.chainsData.filter(r => {
                    return r.id === chainId;
                })[0].countryCode;
            },
            isParentPrj() {
                return this.$store.getters["epoq/isParentPrj"];
            },
            parentPrj() {
                return this.$store.state.parentPrj;
            }
        },
        beforeCreate() {
            this.$store.registerModule("parentPrj", parentPrjManager);
            this.$store.registerModule("epoq", {
                namespaced: true,
                state: {
                    skipQa: 0,
                    sequence: 0,
                    qaData: {},
                    qaDataNGR: {},
                    customer: null,
                    isParentPrj: false,
                    isChild: false,
                    isDetached: false
                },
                getters: {
                    getCustomer(state) {
                        return state.customer;
                    },
                    isParentPrj(state) {
                        return state.isParentPrj;
                    },
                    getChildStatus(state) {
                        return state.isChild;
                    },
                    getDetachedStatus(state) {
                        return state.isDetached;
                    }
                },
                mutations: {
                    reset(state) {
                        state.skipQa = 0;
                        state.sequence = 0;
                        state.qaData = {};
                        state.qaDataNGR = {};
                    },
                    increment(state) {
                        state.sequence++;
                    },
                    setQa(state, qaData) {
                        state.qaData = qaData;
                    },
                    setQaNGR(state, qaData) {
                        state.qaDataNGR = qaData;
                    },
                    setCustomer(state, customer) {
                        state.customer = customer;
                    },
                    closeParentPrj(state) {
                        state.isParentPrj = false;
                    },
                    newParentPrj(state) {
                        state.isParentPrj = true;
                    },
                    newCommonPrj(state) {
                        state.isParentPrj = false;
                    },
                    setChildStatus(state, status) {
                        state.isChild = status;
                    },
                    setDetachedStatus(state, status) {
                        state.isDetached = status;
                    }
                }
            });
        },
        created() {
            this.preferences.config.chainid = localStorage["user_chainid"];
            let user;
            if (this.isCustomer) {
                // CUSTOMER
                // user = this.AzureAgent.getUser();
                let AzureAgent = new UserAgentApplication({
                    auth: {
                        authority: this.checkEnv.getCustomerAuthority() + "/B2C_1A_SUSI_B2C",
                        clientId: this.checkEnv.getCustomerClientId(),
                        knownAuthorities: ["elkjopb2clabs.b2clogin.com", "giganttib2clabs.b2clogin.com", "elgigantendkb2clabs.b2clogin.com", "elgigantenseb2clabs.b2clogin.com", "login.elkjop.no", "login.elgiganten.dk", "login.elgiganten.se", "login.gigantti.fi", "account.elkjop.no", "account.elgiganten.dk", "account.elgiganten.se", "account.gigantti.fi"]
                    }
                });
                user = AzureAgent.getAccount();

                // console.log(user);
                this.preferences.config.isguest = true;
                let chainData = this.checkEnv.getCustomerChainData();
                Auth.guestLogin(this.preferences.config.chainid)
                    .then(profile => {
                        profile.userLang = chainData.countryCode;
                        App.setLangFromUser(profile)
                            .then(() => {
                                App.afterLogin();
                                this.$store.commit("setProfile", profile);
                                if (user !== null) {
                                    // Perform 3cadnext login
                                    this._guestLogin(user)
                                        .then(res => {
                                            this._searchIdentity(
                                                {
                                                    Email: user.idToken.emails[0],
                                                    PhoneNumber: user.idToken.extension_Mobile,
                                                    Country: chainData.countryCode
                                                },
                                                AzureAgent
                                            )
                                                .then(res => {
                                                    this.$store.commit("epoq/setCustomer", res.Identities[0]);
                                                    bus.$emit("elkjop_customer_loggedin");
                                                })
                                                .catch(err => {
                                                    this.$3cadInfo({
                                                        title: this._trans("Service unavailable"),
                                                        body: this._trans(err.message)
                                                    })
                                                        .then(() => {})
                                                        .catch(() => {});
                                                });
                                        })
                                        .catch(errObj => {
                                            let err = errObj.message || errObj;
                                            if (err.indexOf("user not found") > -1) {
                                                let customerData = {
                                                    address: user.idToken.streetAddress,
                                                    cap: user.idToken.postalCode,
                                                    country: chainData.countryCode,
                                                    fullname: user.idToken.given_name + " " + user.idToken.family_name,
                                                    password: user.idToken.extension_elkUserIdentityMasterId,
                                                    extra: user.idToken.extension_elkUserIdentityMasterId,
                                                    phone: user.idToken.name,
                                                    email: user.idToken.emails[0],
                                                    chainid: this.preferences.config.chainid
                                                };
                                                ProjectsAPI.guestAdd(customerData, res => {
                                                    if (res) {
                                                        this._guestLogin(user)
                                                            .then(guestUid => {
                                                                bus.$emit("elkjop_customer_loggedin");
                                                            })
                                                            .catch(logErr => {
                                                                console.log(err);
                                                                AzureAgent.logout();
                                                            });
                                                    }
                                                });
                                            } else {
                                                console.error(err);
                                                AzureAgent.logout();
                                            }
                                        });
                                }
                            })
                            .catch(err => {
                                throw err;
                            });
                    })
                    .catch(err => {
                        throw err;
                    });
            } else {
                // SELLER with ADAL
                NextApiClient.adalAuthData = { isAuthenticated: false, userName: "", loginError: "", profile: "" };
                let _auth = this.adalContext;
                let user = _auth.getCachedUser();

                if (user !== null)
                    this._performAdalLogin(user)
                        .then()
                        .catch(err => {
                            console.error(err);
                            if (_auth._getItem(_auth.CONSTANTS.STORAGE.ERROR) === "access_denied") this.accessError = "User is not allowed to use this application";
                        });
                else {
                    let req = _auth.getRequestInfo(window.location.hash);

                    // Clear window location
                    if (req.valid) {
                        window.location.hash = "";
                        this.adalContext.saveTokenFromHash(req);
                    }

                    // Request from url is valid
                    if (req.valid) {
                        user = _auth.getCachedUser();

                        this._performAdalLogin(user)
                            .then()
                            .catch(err => {
                                console.error(err);
                                if (_auth._getItem(_auth.CONSTANTS.STORAGE.ERROR) === "access_denied") this.accessError = "User is not allowed to use this application";
                            });
                    }
                }
            }
        },
        methods: {
            _checkOldWalls() {
                return new Promise((resolve, reject) => {
                    if (App.iCad.hasOldWalls()) {
                        this.$3cadAsk({
                            title: this._trans("Obsolete walls detected"),
                            body: this._trans("This project contains elements from an obsolete version of the Room Elements catalogue. Do you want to convert the project and switch to the new version?"),
                            okTitle: this._trans("Yes"),
                            cancelTitle: this._trans("No")
                        })
                            .then(data => {
                                App.iCad.convertOldWalls();
                                App.revaluateAllWalls().then(resolve).catch(resolve);
                            })
                            .catch(resolve);
                    } else resolve();
                });
            },
            resetCustomerParams() {
                this.$set(this.prj, "currentVersion", null);
                this.$set(this.prj, "versionNumber", null);
            },
            newB2bPrj() {
                let initPrj = () => {
                    // New parent project
                    this.$store.commit("epoq/newParentPrj");
                    this.$store.commit("parentPrj/empty");
                    this.$store.commit("project/empty");
                    this.$store.commit("erp/reset");

                    // Custom Elkjop ERP params
                    this.$store.commit("epoq/reset");
                    this.resetCustomerParams();

                    //Empty breadcrumb store
                    if (this.$store.state.searchArticle) this.$store.unregisterModule("searchArticle");

                    // this.prj.isopen = true;m
                    this.go("templateview");
                };

                if (this.prj.isopen) {
                    this.$3cadYesNo({
                        title: this._trans("Project not saved"),
                        body: this._trans("Save current project?")
                    })
                        .then(data => {
                            this.prj.isopen = false;
                            this.savePrj()
                                .then(() => {
                                    initPrj();
                                })
                                .catch(err => {
                                    throw err;
                                });
                        })
                        .catch(mode => {
                            if (mode === 0) {
                                this.prj.isopen = false;
                                initPrj();
                            }
                        });
                } else initPrj();
            },
            saveB2bPrj() {
                bus.$emit("startLoading", this._trans("Saving project"));
                this.$store
                    .dispatch("parentPrj/save", {})
                    .then(() => {
                        bus.$emit("stopLoading");
                    })
                    .catch(err => {
                        bus.$emit("stopLoading");
                        throw err;
                    });
            },
            /** Global new project
             * overwrite main navigation method in index.js
             */
            newPrj() {
                let initPrj = customerData => {
                    this.$store.commit("epoq/newCommonPrj");
                    this.$store.commit("project/empty");
                    this.$store.commit("erp/reset");

                    // Custom Elkjop ERP params
                    this.$store.commit("epoq/reset");
                    this.resetCustomerParams();

                    //Empty breadcrumb store
                    if (this.$store.state.searchArticle) this.$store.unregisterModule("searchArticle");

                    if (customerData) {
                        // Add customer data to project
                        this.prj.customercod = customerData.Email;
                        // this.prj.customercod = customerData.IdentityId;

                        // If i have some empty fields it'll be fill with customer info in new project
                        this.prj.orderaddress[0].email = customerData.Email;
                        // this.prj.orderaddress[0].firstname = customerData.fullname.split("\t")[0];
                        this.prj.orderaddress[0].firstname = customerData.FirstName;
                        // this.prj.orderaddress[0].surname = customerData.fullname.split("\t")[1];
                        this.prj.orderaddress[0].surname = customerData.LastName;
                        this.prj.orderaddress[0].postalcode = customerData.Address.PostalCode;
                        this.prj.orderaddress[0].city = customerData.Address.PostalArea;

                        this.prj.orderaddress[0].mobile = customerData.MobileNumber;
                        this.prj.orderaddress[0].street = customerData.Address.Street;
                    } else {
                        console.warn("Missing customer data");
                    }

                    this.prj.orderaddress[0].countrycode = this.countryCode;
                    this.prj.shippingaddress[0].countrycode = this.countryCode;

                    // this.prj.isopen = true;
                    this.go("startprj");
                };

                let getCustomerData = () => {
                    if (this.isCustomer) {
                        let customer = this.$store.getters["epoq/getCustomer"];
                        initPrj(customer);
                    } else {
                        this.checkCustomer()
                            /*.then(data => {
                            this.setCustomerPermission(data)
                                .then(initPrj)
                                .catch(err => {
                                    console.log(err);
                                });
                        })*/
                            .then(initPrj)
                            .catch(err => {
                                bus.$emit("stopLoading");
                                if (err) {
                                    this.$3cadInfo({
                                        title: this._trans("Service unavailable"),
                                        body: this._trans("Service fail or temporarily unavailable")
                                        // body: this._trans(err.message)
                                    })
                                        .then(() => {
                                            initPrj();
                                        })
                                        .catch(() => {
                                            initPrj();
                                        });
                                }
                            });
                    }
                };

                if (this.prj.isopen && !this.isCustomer) {
                    this.$3cadAsk({
                        title: this._trans("Project not saved"),
                        body: this._trans("Save current project?")
                    })
                        .then(data => {
                            this.prj.isopen = false;
                            this.savePrj().then(getCustomerData).catch(getCustomerData);
                        })
                        .catch(mode => {
                            if (mode === 0) {
                                this.prj.isopen = false;
                                getCustomerData();
                            }
                        });
                } else getCustomerData();
            },
            /** Global open project
             * overwrite main navigation method in index.js
             * @param id
             */
            openPrj(id) {
                this.$store.commit("startLoading", { msg: this._trans("Loading project") });
                this.resetCustomerParams();

                // Custom Elkjop ERP params
                this.$store.commit("epoq/reset");
                this.$store.commit("epoq/newCommonPrj");

                this.$store
                    .dispatch("project/load", { id: id })
                    .then(() => {
                        bus.$emit("stopLoading");
                        this._checkOldWalls().then(() => {
                            if (this.$store.state.searchArticle) this.$store.unregisterModule("searchArticle");

                            bus.$emit("stopLoading");

                            if (this.isCustomer) this.go("3dview");
                            else this.go("offerview");
                        });
                    })
                    .catch(() => {
                        bus.$emit("stopLoading");
                    });
            },
            openB2bPrj(id) {
                this.$store.commit("startLoading", { msg: this._trans("Loading project") });
                this.resetCustomerParams();

                // Custom Elkjop ERP params
                this.$store.commit("epoq/reset");
                this.$store.commit("epoq/newParentPrj");
                this.$store.commit("project/empty");

                this.$store
                    .dispatch("parentPrj/load", { id: id })
                    .then(() => {
                        if (this.$store.state.searchArticle) this.$store.unregisterModule("searchArticle");

                        bus.$emit("stopLoading");

                        this.go("templateview");
                    })
                    .catch(() => {
                        bus.$emit("stopLoading");
                    });
            },
            async openB2bChild(id) {
                let { nTemplate, nChild, parentB2B } = await this.$store.dispatch("parentPrj/getChildRefs", { childId: id });

                this.resetCustomerParams();

                // Custom Elkjop ERP params
                this.$store.commit("epoq/reset");
                this.$store.commit("epoq/newParentPrj");
                this.$store.commit("project/empty");

                this.$store
                    .dispatch("parentPrj/load", { id: parentB2B })
                    .then(() => {
                        if (this.$store.state.searchArticle) this.$store.unregisterModule("searchArticle");
                        this.$store.commit("startLoading", { msg: this._trans("Loading child project") });
                        this.$set(this.prj, "b2bHeaderT", {});
                        this.$set(this.prj, "b2bHeaderC", {});
                        this.prj.b2bHeaderC = new B2bHeaderC();

                        this.$store
                            .dispatch("parentPrj/loadChild", {
                                parentId: parentB2B,
                                templateId: nTemplate,
                                childId: nChild
                            })
                            .then(response => {
                                App.getICad().setProject(this.prj);
                                App.getICad().centerZoom();
                                App.getICad().forceSelectObjByUniqueid(this.prj.currentrow);
                                // Select active
                                this.parentPrj.setActiveTempById(nTemplate);
                                bus.$emit("stopLoading");
                                this.go("b2b.3dview");
                            })
                            .catch(err => {
                                bus.$emit("stopLoading");
                                throw err;
                            });
                    })
                    .catch(() => {
                        bus.$emit("stopLoading");
                    });
            },
            async saveB2bTemplate(detach = false) {
                return new Promise((resolve, reject) => {
                    let isChild = this.prj.hasOwnProperty("b2bHeaderC") && this.prj.b2bHeaderC.hasOwnProperty("NChild");

                    if (!isChild && this.prj.hasOwnProperty("b2bHeaderT") && this.prj.b2bHeaderT.isLocked) {
                        // this.$store.commit("project/empty");
                        // this.go("templateview");
                        // return;
                        resolve();
                    }

                    this.$store.commit("startLoading", { msg: this._trans("Saving...") });

                    if (!this.prj.discountamount) this.prj.discountamount = 0;

                    this.prj.delivery.countrycode = this.prj.shippingaddress[0].countrycode || this.prj.orderaddress[0].countrycode || "NO";
                    this.prj.delivery.postalcode = this.prj.shippingaddress[0].postalcode || this.prj.orderaddress[0].postalcode;
                    this.prj.delivery.chain = this.preferences.config.chainid;
                    this.prj.priceDate = new Date().toInt();

                    this.$store
                        .dispatch("project/recompute", {})
                        // Recalculate prices for elkjop
                        .then(json => {
                            epoqRecomputePrices(this.prj, json).finally(() => {
                                // Same as save project
                                let envWall = App.getICad().getEnvWallJson();
                                let dataWall = App.getICad().getCadWrapper().fromWallCadToRows();
                                envWall.wallsProject = { rows: dataWall.rows };
                                this.prj.envWall = envWall;
                                this.prj.envWall.wallsVector = dataWall.wall;
                                this.prj.envWall.windowInstance = dataWall.windowInstance;

                                let tmpPrj = this.prj.getJson();

                                if (isChild) {
                                    this.$store
                                        .dispatch("parentPrj/saveChild", {
                                            prj: this.prj,
                                            config: this.preferences.config,
                                            detach: detach
                                        })
                                        .then(res => {
                                            if (res.b2bHeaderC && res.b2bHeaderC.NChild) {
                                                this.$store.commit("parentPrj/mergeHeader", res.b2bHeaderC);
                                            }
                                            bus.$emit("stopLoading");
                                            resolve(res);
                                        })
                                        .catch(err => {
                                            bus.$emit("stopLoading");
                                            reject(err);
                                        });
                                } else {
                                    this.$store
                                        .dispatch("parentPrj/saveTemplate", {
                                            prj: this.prj,
                                            config: this.preferences.config
                                        })
                                        .then(res => {
                                            if (res.b2bHeaderT && res.b2bHeaderT.NTemplate) {
                                                this.$store.commit("parentPrj/mergeHeader", res.b2bHeaderT);
                                                this.parentPrj.setActiveTempById(res.b2bHeaderT.NTemplate);
                                            }
                                            bus.$emit("stopLoading");
                                            resolve(res);
                                        })
                                        .catch(err => {
                                            bus.$emit("stopLoading");
                                            reject(err);
                                        });
                                }
                            });
                        })
                        .catch();
                });
            },
            async closeB2bTemplate(detach = false) {
                let isChild = this.prj.hasOwnProperty("b2bHeaderC") && this.prj.b2bHeaderC.hasOwnProperty("NChild");

                if (this.prj.b2bHeaderT && (this.prj.b2bHeaderT.status === "INACTIVE" || this.prj.b2bHeaderT.isLocked)) {
                    this.$store.commit("project/empty");
                    this.go("templateview");
                    return;
                }

                this.$3cadYesNo({
                    title: isChild ? this._trans("Child not saved") : this._trans("Template not saved"),
                    body: isChild ? this._trans("Save current child?") : this._trans("Save current template?")
                })
                    .then(async data => {
                        await this.saveB2bTemplate(detach);
                        this.$store.commit("project/empty");
                        if (this.user.seller <= 2) {
                            this.go("home");
                        } else if (isChild) {
                            this.go("childprjview");
                        } else {
                            this.go("templateview");
                        }
                    })
                    .catch(mode => {
                        if (mode === 0) {
                            this.$store.commit("project/empty");
                            if (this.user.seller <= 2) {
                                this.go("home");
                            } else if (isChild) {
                                this.go("childprjview");
                            } else {
                                this.go("templateview");
                            }
                        }
                    });
            },
            async detachB2bChild() {
                try {
                    await this.$3cadAsk({
                        title: this._trans("Detaching child project"),
                        body: this._trans("Are you sure you want to detach the project from the template? This change cannot be reverted")
                    });
                } catch (e) {
                    console.error(e);
                }
                // this.$store.commit("startLoading", {msg: this._trans("Saving...")});
                this.prj.b2bHeaderC.isDetached = true;
                this.saveB2bTemplate(true).then(res => {
                    if (res.b2bHeaderC && res.b2bHeaderC.NChild) {
                        let idTemp = res.b2bHeaderC.NChild;
                        let childHead = this.parentPrj.b2bHeaderC.find(t => {
                            return t.NChild === idTemp;
                        });
                        if (!childHead) {
                            this.parentPrj.b2bHeaderC.push(res.b2bHeaderC);
                        } else {
                            Object.assign(childHead, res.b2bHeaderC);
                        }
                    }
                });
                // Same as save project
                /*let envWall = App.getICad().getEnvWallJson();
            let dataWall = App.getICad().getCadWrapper().fromWallCadToRows();
            envWall.wallsProject = {rows: dataWall.rows};
            this.prj.envWall = envWall;
            this.prj.envWall.wallsVector = dataWall.wall;
            this.prj.envWall.windowInstance = dataWall.windowInstance;
            let tmpPrj = this.prj.getJson();
            tmpPrj.isDetached = true;*/

                /*NextApiClient.com(
                "projectsb2b",
                "jB2BChildSave",
                {
                    jPrj: JSON.stringify(tmpPrj),
                    jView: ''
                },
                res => {
                    bus.$emit("stopLoading");
                    if (res.b2bHeaderC && res.b2bHeaderC.NChild) {
                        let idTemp = res.b2bHeaderC.NChild;0
                        let childHead = this.parentPrj.b2bHeaderC.find(t => {
                            return t.NChild === idTemp;
                        })
                        if (!childHead) {
                            this.parentPrj.b2bHeaderC.push(res.b2bHeaderC);
                        } else {
                            Object.assign(childHead, res.b2bHeaderC);
                        }
                    }
                    this.$store.commit("project/empty");
                    this.go("childprjview");
                },
                err => {
                    bus.$emit("stopLoading");
                    throw err;
                }
            );*/
            },
            /** Navigation function for SPA Application
             * overwrite main navigation method in index.js
             * @param e
             * @param k
             */
            go(e, k) {
                let pattern = /(configurator|[2,3]dview)/i;

                // Previous page
                if (/(configurator|[2,3]dview)/i.test(this.mode)) {
                    lastConfigPage = this.mode;
                    // App.urHistory.saveState( new ChangePageCmd(lastConfigPage, null, this) )
                }

                // Next page
                if (/(configurator|[2,3]dview)/i.test(e) /* && lastConfigPage && lastConfigPage !== e*/) {
                    // Create undo
                    // App.urit.push( new ChangePageCmd(e, lastConfigPage, this) );
                    App.urHistory.saveState(new GeneralCadCmd(e, this, this.prj, App.iCad));
                    //lastConfigPage = e;
                }

                // Check customer
                /*if(this.isCustomer && e === 'home')
                e = 'projects.my';*/

                // Save 2D environment before exit
                if (this.mode === "2dview" || this.mode === "b2b.2dview") {
                    this.$store.commit("cad/wallsToProject", this.prj);
                }

                // Group navigations in method
                let navigation = () => {
                    if (e.cod === "back") {
                        this.mode = this.laststate.cod;
                        this.mnuselect = this.laststate.key;
                    } else {
                        this.mnuselect = k;
                        if (k > 0 && k < 8) {
                            //                  this.laststate.cod=e.cod;

                            this.laststate.cod = e.action;
                            this.laststate.key = k;
                        }
                        //              this.mode=e.cod;
                    }
                    this.mode = e;
                    bus.$emit("changePage");
                };

                // Ask save project
                // if(exitPages.indexOf(e)>-1 && this.prj.isopen && !this.isCustomer) {
                if (exitPages.indexOf(e) > -1 && (this.prj.isopen || this.isParentPrj)) {
                    if (this.isCustomer) {
                        if (!this.prj.status || this.prj.status === "UNASSIGNED" || this.prj.status === "ASSIGNED") {
                            this.$3cadYesNo({
                                title: this._trans("Project not saved"),
                                body: this._trans("Save current project?")
                            })
                                .then(data => {
                                    this.prj.isopen = false;
                                    this.savePrj().then(navigation).catch(navigation);
                                })
                                .catch(mode => {
                                    if (mode === 0) {
                                        this.prj.isopen = false;
                                        navigation();
                                    }
                                });
                        } else {
                            navigation();
                        }
                    } else {
                        if (!this.isParentPrj || (this.isParentPrj && this.user.seller > 2)) {
                            this.$3cadYesNo({
                                title: this._trans("Project not saved"),
                                body: this._trans("Save current project?")
                            })
                                .then(data => {
                                    if (this.isParentPrj) {
                                        this.$store
                                            .dispatch("parentPrj/save", {})
                                            .then(() => {
                                                this.$store.commit("epoq/closeParentPrj");
                                                navigation();
                                            })
                                            .catch(() => {
                                                this.$store.commit("epoq/closeParentPrj");
                                                navigation();
                                            });
                                    } else {
                                        this.prj.isopen = false;
                                        this.savePrj().then(navigation).catch(navigation);
                                    }
                                })
                                .catch(mode => {
                                    if (mode === 0) {
                                        this.$store.commit("epoq/closeParentPrj");
                                        this.prj.isopen = false;
                                        navigation();
                                    }
                                });
                        } else {
                            this.$store.commit("epoq/closeParentPrj");
                            this.prj.isopen = false;
                            navigation();
                        }
                    }
                } else navigation();

                /*if (exitPages.indexOf(e) > -1 && (this.prj.isopen || this.isParentPrj)) {
                if (this.isCustomer) {
                    if (!this.prj.status || this.prj.status === "UNASSIGNED" || this.prj.status === "ASSIGNED") {
                        this.$3cadAsk({
                            title: this._trans("Project not saved"),
                            body: this._trans("Save current project?")
                        })
                            .then(data => {
                                this.prj.isopen = false;
                                this.savePrj().then(navigation).catch(navigation);
                            })
                            .catch(mode => {
                                if (mode === 0) {
                                    this.prj.isopen = false;
                                    navigation();
                                }
                            });
                    } else {
                        navigation();
                    }
                } else {
                    this.$3cadAsk({
                        title: this._trans("Project not saved"),
                        body: this._trans("Save current project?")
                    })
                        .then(data => {
                            this.prj.isopen = false;
                            this.savePrj().then(navigation).catch(navigation);
                        })
                        .catch(mode => {
                            if (mode === 0) {
                                this.prj.isopen = false;
                                navigation();
                            }
                        });
                }
            } else navigation();*/
            },
            /** Do adal login in 3cadnext
             * @param cachedUser
             * @private
             */
            _performAdalLogin(cachedUser) {
                return new Promise((resolve, reject) => {
                    // SELLER with ADAL
                    let token = this.adalContext.getCachedToken(this.adalContext.config.loginResource);

                    if (token == null) reject(this.adalContext.getLoginError());

                    // Show error message
                    NextApiClient.adalAuthData.loginError = this.adalContext.getLoginError();
                    NextApiClient.adalAuthData.isAuthenticated = token != null && token.length > 0 ? token : null;
                    NextApiClient.adalAuthData.userName = cachedUser.userName;
                    NextApiClient.adalAuthData.profile = cachedUser.profile;
                    NextApiClient.adalAuthData.chainId = this.preferences.config.chainid;

                    if (!NextApiClient.adalAuthData.userName) {
                        NextApiClient.adalAuthData.userName = NextApiClient.adalAuthData.profile.upn;
                    }

                    if (!NextApiClient.adalAuthData.userName) {
                        NextApiClient.adalAuthData.userName = NextApiClient.adalAuthData.profile.emails[0];
                    }

                    Auth.adalLogin(NextApiClient.adalAuthData.userName, NextApiClient.adalAuthData.profile.oid, NextApiClient.adalAuthData.chainId)
                        .then(profile => {
                            // Force user to select shop
                            if (profile.shops.length > 1) {
                                profile.shop = null;
                            }

                            this.$store.commit("setProfile", profile);
                            App.setLangFromUser(profile)
                                .then(() => {
                                    bus.$emit("updateNotifications");
                                    App.afterLogin();
                                    resolve(profile);
                                })
                                .catch(reject);
                        })
                        .catch(reject);
                });
            },
            _guestLogin(user) {
                return new Promise((resolve, reject) => {
                    Auth.customerLogin(user.idToken.emails[0], user.idToken.extension_elkUserIdentityMasterId, this.preferences.config.chainid)
                        .then(guestUid => {
                            resolve(guestUid);
                        })
                        .catch(reject);
                });
            },
            /** Elkjop service searchIdentity
             * @param obj
             * @param oidcAgent
             * @returns {Promise<any>}
             * @private
             */
            _searchIdentity(obj, oidcAgent) {
                const params = {
                    _UID: NextApiClient.getUID(),
                    nextbe: NextApiClient.backSite,
                    data: JSON.stringify(obj),
                    endpoint: this.preferences.config.extServices.customerSrv
                };

                if (this.isCustomer) {
                    let user = oidcAgent.getAccount();
                    /*const sessionKey = {
                    authority: oidcAgent.authorityInstance.canonicalAuthority,
                    clientId: this.checkEnv.getCustomerClientId(),
                    homeAccountIdentifier: user.homeAccountIdentifier
                }
                const sessionVal =  JSON.parse(oidcAgent.cacheStorage.getItem(JSON.stringify(sessionKey)))
                const accessToken = sessionVal.accessToken*/

                    params["UGUEST"] = NextApiClient.getGuestUid();
                    params["identityID"] = user.idToken.extension_elkUserIdentityMasterId;
                }

                return new Promise((resolve, reject) => {
                    NextApiClient.combase(
                        this.preferences.config.mediation,
                        "elweb",
                        "SearchIdentity",
                        params,
                        res => {
                            resolve(res);
                        },
                        err => {
                            reject(err);
                        }
                    );
                });
            },
            /** Check/save/update customer in guestbook
             * @returns {Promise|Promise<T>}
             */
            checkCustomer() {
                return new Promise((resolve, reject) => {
                    this.$refs.setCustomer
                        .open({
                            chainId: this.preferences.config.chainid
                        })
                        .$once("close", (mode, data) => {
                            if (mode > 0) {
                                if (data.error) {
                                    data.message = "Service temporarily unavailable";
                                    reject(data);
                                } else resolve(data);
                            } else {
                                reject(null);
                            }
                        });
                });
            },
            /** Set customer permission with epoq services
             * @param guestData
             * @returns {Promise|Promise<T>}
             */
            setCustomerPermission(guestData) {
                return new Promise((resolve, reject) => {
                    this.$refs.setPermissions
                        .open({
                            chainId: this.preferences.config.chainid,
                            customer: guestData
                        })
                        .$once("close", (mode, data) => {
                            if (mode > 0) resolve(guestData);
                            else reject();
                        });
                });
            },
            enableMaintenance() {
                if (this.prj.isopen) {
                    this.$3cadYesNo({
                        title: this._trans("Project not saved"),
                        body: this._trans("Save current project?")
                    })
                        .then(data => {
                            this.savePrj().then(() => {
                                this.$store.commit("project/empty");
                                this.$3cadAsk({
                                    title: this._trans("Enable maintenance mode"),
                                    body: this._trans("Would you like to enable maintenance mode?"),
                                    okTitle: this._trans("Yes"),
                                    cancelTitle: this._trans("No")
                                })
                                    .then(data => {
                                        LogwebAPI.startMaintenance(
                                            {},
                                            data => {
                                                this.$store.commit("setMantainance", {
                                                    isMaintenance: true
                                                });
                                                this.go("home");
                                            },
                                            err => {
                                                console.error(err);
                                            }
                                        );
                                    })
                                    .catch(() => {});
                            });
                        })
                        .catch(mode => {
                            if (mode === 0) {
                                this.$store.commit("project/empty");
                                this.$3cadAsk({
                                    title: this._trans("Enable maintenance mode"),
                                    body: this._trans("Would you like to enable maintenance mode?"),
                                    okTitle: this._trans("Yes"),
                                    cancelTitle: this._trans("No")
                                })
                                    .then(data => {
                                        LogwebAPI.startMaintenance(
                                            {},
                                            data => {
                                                this.$store.commit("setMantainance", {
                                                    isMaintenance: true
                                                });
                                                this.go("home");
                                            },
                                            err => {
                                                console.error(err);
                                            }
                                        );
                                    })
                                    .catch(() => {});
                            }
                        });
                } else {
                    this.$3cadAsk({
                        title: this._trans("Enable maintenance mode"),
                        body: this._trans("Would you like to enable maintenance mode?"),
                        okTitle: this._trans("Yes"),
                        cancelTitle: this._trans("No")
                    })
                        .then(data => {
                            LogwebAPI.startMaintenance(
                                {},
                                data => {
                                    this.$store.commit("setMantainance", {
                                        isMaintenance: true
                                    });
                                    this.go("home");
                                },
                                err => {
                                    console.error(err);
                                }
                            );
                        })
                        .catch(() => {});
                }
            }
        }
    };
</script>
<style scoped lang="scss">
    .content {
        height: 100vh;
    }

    .no-menu {
        padding-top: 0;
    }

    .mid-menu {
        padding-top: 2.45rem;
        @include media-breakpoint-only(md) {
        }
    }

    .full-menu {
        padding-top: 9.9rem;
        @include media-breakpoint-only(xs) {
            padding-top: 7rem;
        }
        @include media-breakpoint-only(sm) {
            padding-top: 7rem;
        }
        @include media-breakpoint-only(md) {
            padding-top: 8rem;
        }
        @include media-breakpoint-only(lg) {
            padding-top: 8rem;
        }
        @include media-breakpoint-only(xl) {
        }

        &.customer-padding {
            padding-top: 8.3rem;
        }
    }

    .full-b2b-menu {
        padding-top: 11.7rem;
        @include media-breakpoint-down(md) {
            padding-top: 5.15rem;
        }

        &.customer-padding {
            padding-top: 8.3rem;
        }
    }

    .username {
        position: absolute;
        bottom: 5px;
        right: 20px;
    }

    .catalog {
        position: absolute;
        width: 120px;
        height: 38px;
        right: 200px;
        background-color: $color;
        border: 0;
        color: $white;
    }

    .catalogoption {
        font-size: 0.8em;
        font-weight: normal;
    }

    .close {
        z-index: 10;
        padding-top: 60px;
    }
</style>



// WEBPACK FOOTER //
// src/custom/epoq/start.vue